<template>
  <div>
    <div class="row">
      <div class="col-12">
        <q-list bordered class="rounded-borders">
          <q-expansion-item 
            dense dark default-opened
            icon="account_tree" 
            header-class="bg-blue-grey-6 text-white"
            expand-icon-class="text-white"
            label="공정 정보" >
            <q-separator />
            <q-card class="q-pa-sm">
              <div class="row">
                <div class="col-xs-12 col-sm-6 col-md-3">
                  <c-label-text title="평가대상공정" :value="process.processName"></c-label-text>
                </div>
                <div class="col-xs-12 col-sm-6 col-md-3">
                  <c-label-text title="작업발생주기" :value="process.workCycleName"></c-label-text>
                </div>
                <div class="col-xs-12 col-sm-6 col-md-3">
                  <c-label-text title="작업시간(1회)" :value="process.workingTime"></c-label-text>
                </div>
              </div>
            </q-card>
          </q-expansion-item>
        </q-list>
      </div>
    </div>
    <c-table
      ref="table"
      title="시나리오 목록"
      :columns="grid.columns"
      :gridHeight="setheight"
      :data="process.fmScenarios"
      :merge="grid.merge"
      :filtering="false"
      :columnSetting="false"
      :usePaging="false"
      :editable="editable&&!disabled"
      selection="multiple"
      rowKey="ram4mAssessScenarioId"
      @callbackProxy="callbackProxy"
      @table-data-change="tableDataChange"
    >
      <!-- @innerBtnClicked="innerBtnClicked" -->
      <!-- 버튼 영역 -->
      <template slot="table-button">
        <q-btn-group outline >
          <c-update-btn 
            name="updateBtn"
            :data="updateBtnData"
            :btnEditable="btnEditable"
            :flagCondition="flagCondition"
            @back="back"
          />
          <c-btn v-if="editable&&!disabled" label="삭제" icon="remove" @btnClicked="removeScenario" />
          <c-btn 
            v-if="editable&&!disabled" 
            :isSubmit="isSave"
            :url="saveUrl"
            :param="process.fmScenarios"
            mappingType="PUT"
            label="저장" 
            icon="save"
            @beforeAction="saveScenario"
            @btnCallback="saveScenarioCallback" />
          <c-btn 
            v-show="editable&&!disabled&&!btnEditable" 
            :isSubmit="isComplete"
            :url="completeUrl"
            :param="process"
            mappingType="PUT"
            :label="'공정[' + process.processName + '] 평가완료'" 
            icon="check"
            @beforeAction="completeProcess"
            @btnCallback="completeProcessCallback" />
        </q-btn-group>
      </template>
      <template v-slot:customArea="{ props, col }">
        <template v-if="col.name==='customCol'">
          <template v-if="!param.vendorFlag">
            <template v-if="props.row['sopImprovementIds'] && props.row['ibmStepNames']">
              <q-chip
                v-for="(item, index) in $comm.ibmTagItems(props.row, colorItems)"
                :key="index"
                :color="item.color"
                :clickable="true"
                text-color="white"
                style="margin-bottom:4px !important;"
                @click="linkClick(item, props.row)">
                {{item.title}}
                <c-assess-tooltip 
                  :ibmTooltip="item.ibmTooltip"
                  :ibmClassCd="item.ibmClassCd"
                />
              </q-chip>
            </template>
            <template v-else>
            </template>
            <div v-if="editable && Boolean(props.row.ram4mAssessScenarioId) && props.row.editFlag !== 'C' && !disabled">
              <q-btn-group outline class="ColumInnerBtnGroup">
                <q-btn
                  icon="add"
                  color="red-6"
                  text-color="white"
                  class="ColumInnerBtn"
                  align="center"
                  @click.prevent="innerBtnClicked(col, props, '1')">
                  <q-tooltip>
                    개선요청등록
                  </q-tooltip>
                </q-btn>
                <q-btn
                  icon="add"
                  color="light-blue"
                  text-color="white"
                  class="ColumInnerBtn"
                  align="center"
                  @click.prevent="innerBtnClicked(col, props, '2')">
                  <q-tooltip>
                    즉시조치등록
                  </q-tooltip>
                </q-btn>
              </q-btn-group>
            </div>
          </template>
          <template v-else>
            <template v-if="props.row['ram4mAssessImprIds'] && props.row['stepFlagNames']">
              <q-chip
                v-for="(item, index) in $comm.fmImprTagItems(props.row)"
                :key="index"
                :color="item.color"
                :clickable="true"
                text-color="white"
                style="margin-bottom:4px !important;"
                @click="linkClick(item, props.row)">
                {{item.title}}
                <c-assess-tooltip 
                  isVendor
                  :ibmTooltip="item.ibmFmTooltip"
                />
              </q-chip>
            </template>
            <template v-else>
            </template>
            <div v-if="editable && Boolean(props.row.ram4mAssessScenarioId) && props.row.editFlag !== 'C' && !disabled">
              <q-btn-group outline class="ColumInnerBtnGroup">
                <q-btn
                  icon="add"
                  color="red-6"
                  text-color="white"
                  class="ColumInnerBtn"
                  align="center"
                  @click.prevent="innerBtnClicked(col, props)">
                  <q-tooltip>
                    개선등록
                  </q-tooltip>
                </q-btn>
              </q-btn-group>
            </div>
          </template>
        </template>
        <template v-else-if="col.name==='picture'">
          <q-btn
            class="tableinnerBtn"
            flat
            align="center"
            color="blue-6"
            label=""
            @click.stop="openPicture(props, col)">
            <template v-slot:default >
              <template v-if="props.row.editFlag!=='C'">
                사진
              </template>
            </template>
          </q-btn>
        </template>
      </template>
    </c-table>
    <c-dialog :param="popupOptions"></c-dialog>
  </div>
</template>

<script>
import { uid } from 'quasar'
import selectConfig from '@/js/selectConfig';
import transactionConfig from '@/js/transactionConfig';
export default {
  name: 'fm-scenario',
  props: {
    process: {
      type: Object,
      default: () => ({
        ramRiskAssessmentPlanId: '',  // 평가 일련번호
        processCd: '',  // 단위공정 코드
        processName: '',  // 단위공정명
        ramProcessAssessStepCd: '',  // 평가진행상태
        processExplainFeature: '',  // 공정 특징 설명
        assessDeptCd: '',  // 평가 부서 코드
        assessUserId: '',  // 평가 담당자
        assessUserName: '',  // 평가 담당자
        workCycleCd: null,  // 작업발생주기코드
        workCycleName: '',  // 작업발생주기
        workingTime: 0,  // 작업시간(1회)
        ramMatrixId: '',
        fmScenarios: [],
      }),
    },
    param: {
      type: Object,
      default: () => ({
        ramRiskAssessmentPlanId: '',
        ramStepCd: '',
        vendorFlag: false,
      }),
    },
    height: {
      type: String,
      default: function() {
        return '';
      },
    },
    planUpdateBtnData: {
      title: '계획',
      flag: false,
      research: '',
      planResearch: '',
    },
  },
  data() {
    return {
      grid: {
        merge: [
          { index: 0, colName: 'jobName' },
          { index: 1, colName: 'ram4mRiskHazardClassGroup' },
        ],
        columns: [],
        data: [],
        height: '600px'
      },
      updateBtnData: {
        title: '평가',
        flag: false,
        research: '',
      },
      colorItems: [],
      requestImprRow: null,
      imprData: null,
      popupOptions: {
        target: null,
        title: '',
        visible: false,
        width: '80%',
        param: {},
        closeCallback: null,
      },
      rowIndex: 0,
      editable: true,
      isSave: false,
      isComplete: false,
      listUrl: '',
      saveUrl: '',
      deleteUrl: '',
      completeUrl: '',
    };
  },
  beforeCreate() {},
  created() {},
  beforeMount() {
    Object.assign(this.$data, this.$options.data());
  },
  mounted() {
    this.init();
  },
  beforeDestroy() {
  },
  computed: {
    disabled() {
      return (!(this.param.ramStepCd === 'R4RS00005' || this.param.ramStepCd == 'R4RS00010') || this.process.ramProcessAssessStepCd === 'RPA0000005')
        && !this.updateBtnData.flag
    },
    setheight() {
      let pxRemove = this.height.replace('px', '');
      return this.height && this.height.indexOf('px') > -1 && !isNaN(pxRemove) ? (Number(pxRemove) - 150) + 'px' : '500px'
    },
    btnEditable() {
      return this.editable && this.param.ramStepCd === 'R4RS00010' && this.process.ramProcessAssessStepCd === 'RPA0000005'
    },
    flagCondition() {
      return this.param.ramStepCd === 'R4RS00010'
    },
  },
  methods: {
    init() {
      // role setting
      this.editable = this.$route.meta.editable;
      // url setting
      this.listUrl = selectConfig.ram.fm.scenario.list.url
      this.saveUrl = transactionConfig.ram.fm.scenario.save.url
      this.deleteUrl = transactionConfig.ram.fm.scenario.delete.url
      this.completeUrl = transactionConfig.ram.assessProcess.complete.url;
      // code setting
      this.$comm.getStepItems('IBM_STEP_CD').then(_result => {
        this.colorItems = _result
      });
      this.$comm.getComboItems('RAM_OCCURR_CLASS_CD').then(_result => {
        this.grid.columns = [
          {
            name: 'jobName',
            field: 'jobName',
            label: '작업',
            align: 'left',
            style: 'width:150px',
            sortable: false,
          },
          {
            name: 'ram4mRiskHazardClassName',
            field: 'ram4mRiskHazardClassName',
            label: '평가구분(4M)',
            align: 'center',
            style: 'width:90px',
            sortable: false,
          },
          {
            name: 'riskHazardName',
            field: 'riskHazardName',
            label: '유해위험요인',
            align: 'left',
            style: 'width:170px',
            sortable: false,
          },
          {
            name: 'imprCost',
            field: 'imprCost',
            label: '개선비용',
            align: 'right',
            style: 'width:120px',
            type: 'number',
            sortable: false,
          },
          {
            name: 'ramOccurrClassCd',
            field: 'ramOccurrClassCd',
            label: '발생형태',
            align: 'center',
            type: 'select',
            style: 'width:100px',
            sortable: false,
            comboItems: _result
          },
          {
            name: 'damageTypeName',
            field: 'damageTypeName',
            label: '재해형태',
            align: 'left',
            type: 'text',
            style: 'width:120px',
            sortable: false,
          },
          {
            name: 'existingRiskManagementActivities',
            field: 'existingRiskManagementActivities',
            label: '기존 리스크관리 활동',
            align: 'left',
            type: 'textarea',
            style: 'width:180px',
            sortable: false,
          },
          {
            name: 'before',
            field: 'before',
            label: '개선전',
            align: 'center',
            child: [
              {
                name: 'beforeFrequency',
                field: 'beforeFrequency',
                label: '빈도',
                align: 'center',
                style: 'width:50px',
                sortable: false
              },
              {
                name: 'beforeStrength',
                field: 'beforeStrength',
                label: '강도',
                align: 'center',
                style: 'width:50px',
                sortable: false
              },
              {
                name: 'beforeRisk',
                field: 'beforeRisk',
                label: '위험도',
                align: 'center',
                style: 'width:70px',
                sortable: false,
                required: true,
                type: 'proxy',
                component: () => import(`${'@/pages/ram/base/matrixPop.vue'}`)
              },
            ]
          },
          // {
          //   name: 'picture',
          //   field: 'picture',
          //   label: '개선 전/후<br/>사진',
          //   align: 'center',
          //   type: 'custom',
          //   style: 'width:90px',
          //   sortable: false,
          // },
          {
            name: 'after',
            field: 'after',
            label: '개선후',
            align: 'center',
            child: [
              {
                name: 'afterFrequency',
                field: 'afterFrequency',
                label: '빈도',
                align: 'center',
                style: 'width:50px',
                sortable: false
              },
              {
                name: 'afterStrength',
                field: 'afterStrength',
                label: '강도',
                align: 'center',
                style: 'width:50px',
                sortable: false
              },
              {
                name: 'afterRisk',
                field: 'afterRisk',
                label: '위험도',
                align: 'center',
                style: 'width:70px',
                sortable: false,
                required: true,
                type: 'proxy',
                component: () => import(`${'@/pages/ram/base/matrixPop.vue'}`)
              },
            ]
          },
          {
            name: 'assessDate',
            field: 'assessDate',
            label: '평가일',
            align: 'center',
            type: 'date',
            style: 'width:130px',
            sortable: false,
            required: true,
          },
          {
            name: 'assessUserName',
            field: 'assessUserName',
            label: '평가자',
            align: 'center',
            type: !this.param.vendorFlag ? 'user' : 'text',
            userId: 'assessUserId',
            style: 'width:100px',
            sortable: false,
            required: true,
          },
          {
            name: 'damageTargetName',
            field: 'damageTargetName',
            label: '피해대상',
            align: 'left',
            style: 'width:120px',
            type: 'text',
            sortable: false,
          },
          {
            name: 'impr',
            field: 'impr',
            label: '개선진행',
            align: 'center',
            child: [
              {
                name: 'customCol',
                field: 'customCol',
                label: '개선번호/개선진행상태',
                align: 'center',
                style: 'width:150px',
                type: 'custom',
                sortable: false
              },
            ]
          },
        ]
        if (!this.param.vendorFlag) {
          this.grid.columns.splice(14, 0, {
            name: 'riskbookFlag',
            field: 'riskbookFlag',
            label: '위험등록부',
            align: 'center',
            sortable: true,
            type: 'check',
            'true': 'Y',
            'false': 'N',
            // disableTarget: 'riskRegisterFlag',
            // disableCon: false
          })
        }
      });
      // list setting
    },
    getList() {
      this.$http.url = this.listUrl;
      this.$http.type = 'GET';
      this.$http.param = {
        ramRiskAssessmentPlanId: this.process.ramRiskAssessmentPlanId,
        processCd: this.process.processCd,
      }
      this.$http.request((_result) => {
        this.process.fmScenarios = _result.data;
      },);
    },
    research() {
      this.$emit('research', 'scenario')
    },
    /* eslint-disable no-unused-vars */
    innerBtnClicked(col, props, btn) {
      if (col.name === 'riskHazardNameClass') {
        if (btn.value === '1') {
          this.rowIndex = props.rowIndex;
          this.popupOptions.title = '유해위험요인별 원인/결과'; // 유해위험요인별 원인/결과
          this.popupOptions.param = {
            type: 'multiple',
            searchType: '7', //1: 작업조회, 2:작업단계, 3:작업단계별 유해위험요인, 4:작업단계별 유해위험요인별 원인/결과
            subProcessCd: this.process.processCd,
            mdmSopId: props.row.mdmSopId,
          };
          this.popupOptions.target = () => import(`${'@/pages/common/process/sopPop.vue'}`);
          this.popupOptions.width = '70%';
          this.popupOptions.visible = true;
          this.popupOptions.closeCallback = this.closeCausePopup;
        } else {
          this.process.fmScenarios.splice(props.rowIndex, 0, {
            ram4mAssessScenarioId: uid(),  // 시나리오 일련번호_시나리오의 한 라인(원일별)
            ramRiskAssessmentPlanId: this.process.ramRiskAssessmentPlanId,  // 평가 일련번호
            processCd: this.process.processCd,  // 단위공정 코드
            ramRiskHazardClassCd: props.row.ramRiskHazardClassCd,  // 유해위험분류 코드
            ramRiskHazardId:props.row.ramRiskHazardId,  // 유해위험요인 코드
            riskHazardName: props.row.riskHazardName,  // 유해위험요인 명
            riskHazardNameClass: props.row.riskHazardNameClass,  // 유해위험요인 명
            riskOccurrenceCause: '',  // 위험발생 원인
            riskOccurrenceResult: '',  // 위험발생 결과
            relationLaw: '',  // 관련법규_유해위험요인 마스터에스 불러와서 편집후 저장
            currentSafetyMeasures: '',  // 현재 안전조치
            beforeRamMatrixRiskId: '',  // 전 위험도 no
            afterRamMatrixRiskId: '',  // 후 위험도 no
            assessDate: this.$comm.getToday(),  // 평가일
            assessUserName: this.$_.clone(this.process.assessUserName),
            assessUserId: this.$_.clone(this.process.assessUserId),
            ram4mAssessImprIds: '', 
            stepFlagNames: '', 
            sopImprovementIds: '', 
            ibmStepNames: '', 
            riskbookFlag: 'N', 
            editFlag: 'C',
            ramMatrixId: this.process.ramMatrixId,
            // 위험등록부 등재를 위한 prop
            riskRegisterFlag: false,
          });
        }
      } else if (col.name === 'customCol') {
        this.requestImprRow = props.row
        let requestContents = props.row.jobName + ' / '
          + props.row.ram4mRiskHazardClassName + ' / '
          + props.row.riskHazardName;
        if (!this.param.vendorFlag) {
          if (btn === '1') {
            this.popupOptions.title = '개선 요청';
            this.popupOptions.param = {
              requestContents: requestContents,
              relationTableKey: props.row.ram4mAssessScenarioId,
              ibmTaskTypeCd: 'ITT0000023',
            };
            this.popupOptions.target = () => import(`${'@/pages/sop/ibm/imprRequest.vue'}`);
          } else {
            this.popupOptions.title = '즉시조치';
            this.popupOptions.param = {
              requestContents: requestContents,
              relationTableKey: props.row.ram4mAssessScenarioId,
              ibmTaskTypeCd: 'ITT0000023',
            };
            this.popupOptions.target = () => import(`${'@/pages/sop/ibm/imprImmediate.vue'}`);
          }
        } else {
          this.popupOptions.title = '개선';
          this.popupOptions.param = {
            requestContents: requestContents,
            ram4mAssessScenarioId: props.row.ram4mAssessScenarioId,
          };
          this.popupOptions.target = () => import(`${'@/pages/ram/4m/risk/4mImprRiskReduce.vue'}`);
        }
        this.popupOptions.width = '90%';
        this.popupOptions.visible = true;
        this.popupOptions.closeCallback = this.closeAddImprPopup;
      }
    },
    closeCausePopup(data) {
      this.popupOptions.target = null;
      this.popupOptions.visible = false;

      if (data && data.length > 0) {
        this.$_.forEach(data, item => {
          this.process.fmScenarios.splice(this.rowIndex, 0, {
            ram4mAssessScenarioId: uid(),  // 시나리오 일련번호_시나리오의 한 라인(원일별)
            ramRiskAssessmentPlanId: this.process.ramRiskAssessmentPlanId,  // 평가 일련번호
            processCd: this.process.processCd,  // 단위공정 코드
            mdmSopId: item.mdmSopId,  // 안전작업 표준 일련번호_sop 작업이 아닌경우는 "tmp_001"과 같이 생성
            jobName: item.sopName,  // 안전작업 명
            ramRiskHazardId: item.mdmHazardFactorsId,  // 유해위험요인 번호
            riskHazardName: item.riskHazardName,  // 유해위험요인명
            ram4mRiskHazardClassCd: null,  // 4M 분류 코드
            ram4mRiskHazardClassName: '',  // 4M 분류
            imprCost: null, // 개선비용
            damageTargetName: '',  // 피해대상(key-in)
            damageTypeName: '',  // 재해형태(key-in)
            existingRiskManagementActivities: '',  // 기존 리스크 관리활동
            addingRiskManagementActivities: '',  // 추가 리스크 관리활동
            beforeRamMatrixRiskId: '',  // 전 위험도 no
            afterRamMatrixRiskId: '',  // 후 위험도 no
            assessDate: this.$comm.getToday(),  // 평가일
            assessUserName: this.$_.clone(this.process.assessUserName),
            assessUserId: this.$_.clone(this.process.assessUserId),
            sopImprovementIds: '', 
            ibmStepNames: '', 
            ram4mAssessImprIds: '', 
            stepFlagNames: '', 
            riskbookFlag: 'N', 
            editFlag: 'C',
            ramMatrixId: this.process.ramMatrixId,
            // 위험등록부 등재를 위한 prop
            riskRegisterFlag: false,
            regUserId: this.$store.getters.user.userId,  // 작성자 ID
          });
        });
      }
    },
    closeAddImprPopup(data) {
      this.popupOptions.target = null;
      this.popupOptions.visible = false;

      if (data && data.length > 0) {
        if (!this.param.vendorFlag) {
          this.$_.forEach(data, item => {
            let sData = this.requestImprRow.sopImprovementIds ? this.requestImprRow.sopImprovementIds : '';
            if (sData.indexOf(item.sopImprovementId) === -1) {
              this.requestImprRow.sopImprovementIds = this.requestImprRow.sopImprovementIds ? 
                this.requestImprRow.sopImprovementIds + ',' + item.sopImprovementId : item.sopImprovementId
              this.requestImprRow.ibmStepNames = this.requestImprRow.ibmStepNames ? 
                this.requestImprRow.ibmStepNames + ',' + item.ibmStepName : item.ibmStepName
              this.requestImprRow.ibmClassCds = this.requestImprRow.ibmClassCds ? 
                this.requestImprRow.ibmClassCds + ',' + item.ibmClassCd : item.ibmClassCd
              this.requestImprRow.ibmTooltip = this.requestImprRow.ibmTooltip ? 
                this.requestImprRow.ibmTooltip + ',' + item.ibmTooltip : item.ibmTooltip
            }
          })
        } else {
          this.$_.forEach(data, item => {
            let sData = this.requestImprRow.ram4mAssessImprIds ? this.requestImprRow.ram4mAssessImprIds : '';
            if (sData.indexOf(item.ram4mAssessImprId) === -1) {
              this.requestImprRow.ram4mAssessImprIds = this.requestImprRow.ram4mAssessImprIds ? 
                this.requestImprRow.ram4mAssessImprIds + ',' + item.ram4mAssessImprId : item.ram4mAssessImprId
              this.requestImprRow.stepFlagNames = this.requestImprRow.stepFlagNames ? 
                this.requestImprRow.stepFlagNames + ',' + item.stepFlagName : item.stepFlagName
              this.requestImprRow.ibmFmTooltip = this.requestImprRow.ibmFmTooltip ? 
                this.requestImprRow.ibmFmTooltip + ',' + item.ibmFmTooltip : item.ibmFmTooltip
            }
          })
        }
        this.$refs['table'].$refs['compo-table'].resetVirtualScroll();
        this.research();
      }
    },
    linkClick(data, row) {
      this.requestImprRow = row
      this.imprData = data;
      if (!this.param.vendorFlag) {
        if (data.ibmClassCd === 'IC00000001') {
          this.popupOptions.title = '개선';
          this.popupOptions.param = {
            sopImprovementId: data.sopImprovementId,
          };
          this.popupOptions.target = () => import(`${'@/pages/sop/ibm/imprDetail.vue'}`);
        } else {
          this.popupOptions.title = '즉시조치';
          this.popupOptions.param = {
            sopImprovementId: data.sopImprovementId,
          };
          this.popupOptions.target = () => import(`${'@/pages/sop/ibm/imprImmDetail.vue'}`);
        }
      } else {
        this.popupOptions.title = '개선';
        this.popupOptions.param = {
          ram4mAssessImprId: data.ram4mAssessImprId,
        };
        this.popupOptions.target = () => import(`${'@/pages/ram/4m/risk/4mImprRiskReduceDetail.vue'}`);
      }
      this.popupOptions.width = '90%';
      this.popupOptions.visible = true;
      this.popupOptions.closeCallback = this.closeImprPopup;
    },
    closeImprPopup(result, flag) {
      this.popupOptions.target = null;
      this.popupOptions.visible = false;
      if (result && result.col1) {
        if (!this.param.vendorFlag) {
          if (flag !== 'delete') {
            if (result.col1.ibmStepCd === 'IS00000010' || result.col1.ibmStepCd === 'IS00000015' || result.col1.ibmStepCd === 'IS00000020') {
              this.requestImprRow.riskRegisterFlag = true
            }
            let splitId = this.$_.split(this.requestImprRow.sopImprovementIds, ',');
            let splitStep = this.$_.split(this.requestImprRow.ibmStepNames, ',');
            if (splitId && splitId.length > 0) {
              let idIndex = this.$_.indexOf(splitId, result.col1.sopImprovementId);
              splitStep[idIndex] = result.col1.ibmStepName;
              this.requestImprRow.ibmStepNames = splitStep.toString();
            }
          } else {
            let splitId = this.$_.split(this.requestImprRow.sopImprovementIds, ',');
            let splitStep = this.$_.split(this.requestImprRow.ibmStepNames, ',');
            let splitClass = this.$_.split(this.requestImprRow.ibmClassCds, ',');
            if (splitId && splitId.length > 0) {
              let idIndex = this.$_.indexOf(splitId, result.col1.sopImprovementId);
              splitId.splice(idIndex, 1)
              splitStep.splice(idIndex, 1)
              splitClass.splice(idIndex, 1)
              this.$set(this.requestImprRow, 'sopImprovementIds', splitId.toString())
              this.$set(this.requestImprRow, 'ibmStepNames', splitStep.toString())
              this.$set(this.requestImprRow, 'ibmClassCds', splitClass.toString())
            }
          }
        } else {
          if (flag !== 'delete') {
            let splitId = this.$_.split(this.requestImprRow.ram4mAssessImprIds, ',');
            let splitStep = this.$_.split(this.requestImprRow.stepFlagNames, ',');
            if (splitId && splitId.length > 0) {
              let idIndex = this.$_.indexOf(splitId, result.col1.ram4mAssessImprId);
              splitStep[idIndex] = result.col1.stepFlagName;
              this.requestImprRow.stepFlagNames = splitStep.toString();
            }
          } else {
            let splitId = this.$_.split(this.requestImprRow.ram4mAssessImprIds, ',');
            let splitStep = this.$_.split(this.requestImprRow.stepFlagNames, ',');
            if (splitId && splitId.length > 0) {
              let idIndex = this.$_.indexOf(splitId, result.col1.ram4mAssessImprId);
              splitId.splice(idIndex, 1)
              splitStep.splice(idIndex, 1)
              this.$set(this.requestImprRow, 'ram4mAssessImprIds', splitId.toString())
              this.$set(this.requestImprRow, 'stepFlagNames', splitStep.toString())
            }
          }
        }
        this.$refs['table'].$refs['compo-table'].resetVirtualScroll();
        this.research();
      }
    },
    openPicture(props, col) {
      this.popupOptions.title = '개선 전/후 사진';
      this.popupOptions.param = {
        ram4mAssessScenarioId: props.row.ram4mAssessScenarioId,
        disabled: this.disabled
      };
      this.popupOptions.target = () => import(`${'./4mScenarioImprPicture.vue'}`);
      this.popupOptions.width = '70%';
      this.popupOptions.visible = true;
      this.popupOptions.closeCallback = this.closeScenarioImprPicturePopup;
    },
    closeScenarioImprPicturePopup(result) {
      this.popupOptions.target = null;
      this.popupOptions.visible = false;
    },
    /* eslint-disable no-unused-vars */
    callbackProxy(data, props, col) {
      if (col.name === 'beforeRisk') {
        this.$set(this.process.fmScenarios[props.rowIndex], 'beforeFrequency', data.f)
        this.$set(this.process.fmScenarios[props.rowIndex], 'beforeStrength', data.s)
        this.$set(this.process.fmScenarios[props.rowIndex], 'beforeRisk', data.r)
        this.$set(this.process.fmScenarios[props.rowIndex], 'beforeRamMatrixRiskId', data.ramMatrixRiskId)
      } else {
        this.$set(this.process.fmScenarios[props.rowIndex], 'afterFrequency', data.f)
        this.$set(this.process.fmScenarios[props.rowIndex], 'afterStrength', data.s)
        this.$set(this.process.fmScenarios[props.rowIndex], 'afterRisk', data.r)
        this.$set(this.process.fmScenarios[props.rowIndex], 'afterRamMatrixRiskId', data.ramMatrixRiskId)
      }
      if (this.process.fmScenarios[props.rowIndex].editFlag !== 'C') {
        this.$set(this.process.fmScenarios[props.rowIndex], 'editFlag', 'U')
        this.$set(this.process.fmScenarios[props.rowIndex], 'chgUserId', this.$store.getters.user.userId)
      }
    },
    tableDataChange(props, col) {
      /**
       * 협력업체 포탈에서는 평가자는 key-in
       * 따라서 평가자를 수정할 시에 id를 제거하도록 처리
       */
      if (col.name === 'assessUserName' && this.param.vendorFlag) {
        this.$set(props.row, 'assessUserId', '')
      }
    },
    saveScenario() {
      if (this.$comm.validTable(this.grid.columns, this.process.fmScenarios)) {
        window.getApp.$emit('CONFIRM', {
          title: '확인',
          message: '저장하시겠습니까?',
          // TODO : 필요시 추가하세요.
          type: 'info', // success / info / warning / error
          // 확인 callback 함수
          confirmCallback: () => {            
            this.isSave = !this.isSave
          },
          // 취소 callback 함수
          cancelCallback: () => {
          },
        });
      }
    },
    saveScenarioCallback() {
      window.getApp.$emit('APP_REQUEST_SUCCESS');
      this.research();
      this.getList();
    },
    removeScenario() {
      let selectData = this.$refs['table'].selected;
      if (!selectData || selectData.length === 0) {
        window.getApp.$emit('ALERT', {
          title: '안내', // 안내
          message: '하나 이상 선택하세요.', // 하나 이상 선택하세요.
          type: 'warning', // success / info / warning / error
        });
      } else {
        window.getApp.$emit('CONFIRM', {
          title: '확인',
          message: '삭제하시겠습니까?',
          // TODO : 필요시 추가하세요.
          type: 'info', // success / info / warning / error
          // 확인 callback 함수
          confirmCallback: () => {
            this.$http.url = this.deleteUrl;
            this.$http.type = 'DELETE';
            this.$http.param = {
              data: Object.values(selectData),
            };
            this.$http.request(() => {
              window.getApp.$emit('APP_REQUEST_SUCCESS');
              this.$_.forEach(selectData, item => {
                this.process.fmScenarios.splice(this.$_.findIndex(this.process.fmScenarios, item), 1)
              })
              this.$refs['table'].$refs['compo-table'].clearSelection();

              this.planUpdateBtnData.planResearch = uid();
            },);
          },
          // 취소 callback 함수
          cancelCallback: () => {
          },
        });
      }
    },
    completeProcess() {
      // 도면 별 노드에 시나리오가 하나 이상 등록되었는지?
      // 화면에서 추가는 하고 저장을 하지 않았을 시에 해당 데이터도 일괄 저장 처리
      // 저장 처리 후 callback에서 process 목록 재조회
      let isProgress = true;
      if (!this.process.fmScenarios || this.process.fmScenarios.length === 0) {
        isProgress = false
        window.getApp.$emit('ALERT', {
          title: '안내', // 안내
          message: '공정 [' + this.process.processName + ']에 등록된 시나리오가 없습니다.',
          type: 'warning', // success / info / warning / error
        });
      }

      if (isProgress && this.$comm.validTable(this.grid.columns, this.process.fmScenarios)) {
        window.getApp.$emit('CONFIRM', {
          title: '확인',
          message: '완료하시겠습니까?',
          // TODO : 필요시 추가하세요.
          type: 'info', // success / info / warning / error
          // 확인 callback 함수
          confirmCallback: () => {
            this.process.chgUserId = this.$store.getters.user.userId
            this.process.ramProcessAssessStepCd = 'RPA0000005';

            this.isComplete = !this.isComplete
          },
          // 취소 callback 함수
          cancelCallback: () => {
          },
        });
      }
    },
    completeProcessCallback(_result) {
      window.getApp.$emit('APP_REQUEST_SUCCESS');
      this.$emit('assessComplete', _result.data)

      this.planUpdateBtnData.planResearch = uid();
    },
    /**
     * 재조회
     * 목적 : 돌아가기전 데이터를 저장 했을 수도 있지만 
     *        입력만 하고 돌아가는 경우를 대비하기 위함
     */
    back() {
      this.getList();
    },
  }
};
</script>
<style lang="sass">
.scenario-chip i 
  margin-right: -0.2em !important
</style>
